import { render, staticRenderFns } from "./BeanTypeSelect.vue?vue&type=template&id=9b247620&"
import script from "./BeanTypeSelect.vue?vue&type=script&lang=js&"
export * from "./BeanTypeSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports